import { Handle } from '@xyflow/react';
import { getHandlePositions } from './nodeLayout';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import React, { memo } from 'react';
import classes from '../FlowNodes.module.scss';
import { HANDLE_PIN_TO_CARD_CENTER } from '../consts';

/**
 * ByoSourceShellNode — dashed placeholder for the SOURCE node in the BYO
 * create flow, before the user configures a real source. Visually identical to
 * the CODE shell so all three (source / code / destination) look consistent on
 * the canvas. Clicking opens the source-setup form via the `onByoSourceClick`
 * callback forwarded through nodeProps.
 */
const ByoSourceShellNode = memo((props: any) => {
  const { data } = props;
  const onByoSourceClick: (() => void) | undefined = data?.onByoSourceClick;
  const sourcePosition = getHandlePositions(data?.layoutDirection).source;

  return (
    <div style={{ whiteSpace: 'nowrap' }} data-testid="byo-canvas-source-node">
      <div style={{ position: 'relative', width: 232 }}>
        <button type="button" className={classes.codeShell} onClick={onByoSourceClick}>
          <span className={classes.shellRow}>
            <LockOutlinedIcon className={classes.shellIcon} />
            <span className={classes.shellTitle}>+ Source</span>
          </span>
        </button>
      </div>
      <div className={classes.shellFooter}>
        <span className={classes.shellBadge}>Not configured</span>
        <span className={classes.shellCaption}>Step 1: Select a folder</span>
      </div>
      <Handle
        isConnectable={false}
        type="source"
        position={sourcePosition}
        id="right"
        style={
          data?.layoutDirection === 'TB' ? { left: '50%' } : { top: HANDLE_PIN_TO_CARD_CENTER }
        }
      />
    </div>
  );
});
ByoSourceShellNode.displayName = 'ByoSourceShellNode';

export default ByoSourceShellNode;
